/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type RansomwareRecoveryProvisionModeEnum = 'BYOL' | 'VMWARE_MANAGED';

export const RansomwareRecoveryProvisionModeEnum = {

    BYOL: 'BYOL' as RansomwareRecoveryProvisionModeEnum,

    VMWARE_MANAGED: 'VMWARE_MANAGED' as RansomwareRecoveryProvisionModeEnum
};

